<template>
  <v-container>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm8 md6>
        <v-card>
          <v-toolbar card color="white">
            <v-text-field

              flat
              hide-details
              :placeholder="$t('search')"
              prepend-icon="search"
              solo
              v-model="search"
            ></v-text-field>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <div class="v-table__overflow">
              <v-data-table
                :headers="headers"
                :items="participants"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                :search="search"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="px-2 body-2">{{props.item.name}}</td>
                  <td class="px-2">
                    <v-chip
                      color="primary"
                      class="body-2"
                      small
                      dark
                      v-for="(team, index) in props.item.teams"
                      :key="index+300"
                    >{{team}}</v-chip>
                  </td>
                </template>
              </v-data-table>
              <!-- <table
                class="v-datatable v-table theme--light"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th class="body-2">{{$t('name')}}</th>
                    <th class="body-2">{{$tc('team',2)}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(participant, index) in participants" :key="index+200">
                    <td class="px-2 body-2">{{participant.name}}</td>
                    <td class="px-2">
                      <v-chip
                        color="primary"
                        class="body-2"
                        small
                        dark
                        v-for="(team, index) in participant.teams"
                        :key="index+300"
                      >{{team}}</v-chip>
                    </td>
                  </tr>
                </tbody>
              </table>-->
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'tabParticipants',
  data () {
    return {
      search: ''
    }
  },
  computed: {
    ...mapState({
      entity: state => state.entities.entitySelected
    }),
    participants () {
      if (!this.entity || !this.entity.participants) return []
      return this.entity.participants
    },
    headers () {
      return [
        {
          text: this.$t('name'),
          value: 'name'
        },
        {
          text: this.$tc('team', 2),
          value: 'teams'
        }

      ]
    }
  }
}
</script>
